import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function ZendeskMonoIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 21 17" {...props}>
      <Box
        as="path"
        fill="currentColor"
        d="M9.701 5.123v11.713H0L9.701 5.123Zm0-4.202a4.844 4.844 0 0 1-4.845 4.845A4.853 4.853 0 0 1 0 .921h9.701ZM11.3 16.836a4.844 4.844 0 0 1 4.846-4.845 4.844 4.844 0 0 1 4.845 4.845H11.3Zm0-4.202V.921H21l-9.7 11.713Z"
      />
    </Icon>
  );
}
